import { Outlet, createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import AuthenticatedNavigation from '@/components/authenticated-navigation';
import { clearAuthContext, isSessionValid } from '@/utils/router-auth';
import { storage } from '@/utils/storage';
import { hasCompletedOnboarding } from '@/utils/onboarding';
import { OrganizationProvider } from '@/contexts/organization-context';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    if (!isSessionValid()) {
      clearAuthContext();
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href
        }
      });
    }

    const projectId = storage.getProjectId();
    const onboardingCompleted = hasCompletedOnboarding();

    if (!projectId && !onboardingCompleted && location.pathname !== '/onboarding') {
      throw redirect({
        to: '/onboarding'
      });
    }
  },
  component: AuthenticatedLayout
});

function AuthenticatedLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuthContext();
    navigate({ to: '/' });
  };

  return (
    <OrganizationProvider>
      <AuthenticatedNavigation onLogout={handleLogout} />
      <Outlet />
    </OrganizationProvider>
  );
}
